export function HeartRateFilter(value: number) {
    if (isNaN(value)) {
        return "0 bpm";
    }

    return value.toFixed(0) + " bpm";
}
